import { render, staticRenderFns } from "./form8.vue?vue&type=template&id=783530d4&scoped=true"
import script from "./form8.vue?vue&type=script&lang=js"
export * from "./form8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783530d4",
  null
  
)

export default component.exports